// 账户信息
export const accounts = {
    spot: {
        name: '现货账户',
        key: 'loan_spot_account',
        type: 1,
    },
    contract: {
        name: '合约账户',
        key: 'contract_account',
        type: 2,
    },
    option: {
        name: 'USDC合约账户',
        key: 'usdc_contract_account',
        type: 3,
    },
    inverse: {
        name: '反向合约账户',
        key: 'reverse_contract_account',
        type: 4,
    },
    fund: {
        name: '资金帐户',
        key: 'funding',
        type: 5,
    },
    uta: {
        name: '统一交易账户',
        key: 'unifiedAccount',
        type: 6,
    },
};

export const accountMap = {
    1: {
        name: '现货账户',
        key: 'loan_spot_account',
        type: 1,
    },
    2: {
        name: '合约账户',
        key: 'contract_account',
        type: 2,
    },
    3: {
        name: 'USDC合约账户',
        key: 'usdc_contract_account',
        type: 3,
    },
    4: {
        name: '反向合约账户',
        key: 'reverse_contract_account',
        type: 4,
    },
    5: {
        name: '资金帐户',
        key: 'funding',
        type: 5,
    },
    6: {
        name: '统一交易账户',
        key: 'unifiedAccount',
        type: 6,
    },
};
